import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { routePaths } from "../../../../config/route-paths";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  titleColor: {
    color: theme.palette.ePrimary?.base,
  },
  backColor: {
    color: theme.palette.ePrimary?.base,
    backgroundColor: "none",
  },
}));

export default function SearchHeader({ keyword, searchContent, contentReady }) {
  const classes = useStyles();
  const history = useHistory();

  const {t:labels, ready: labelReady} = useTranslation("label-E_SEARCH_RESULT")
  const backCall = () => {
    if (history.length >= 1) {
      history.goBack();
    } else {
      history.push(routePaths.HOME);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        {labelReady ? (
          <Button
            className={classes.backColor}
            size="small"
            startIcon={
              <ArrowBackIosIcon fontSize="small" className="marginRight" />
            }
            onClick={backCall}
          >
            <b>{labels("E_SEARCH_BACK")}</b>
          </Button>
        ) : (
          <Skeleton />
        )}
      </Grid>
      <Grid item xs={12}>
      {
        labelReady ?
        <Typography variant="h5" className={classes.titleColor}>
          <b>{labels("E_SEARCH_TITLE")}</b>
        </Typography>
        : <Skeleton />
      }
      </Grid>
      {keyword ? (
        <Grid item xs={12}>
        {
          contentReady ?
          <Typography variant="subtitle1">{
            searchContent("E_SEARCH_RESULTS_STATEMENT").answer?.replace("<keyword>", keyword
            )}</Typography>
            : <Skeleton />
        }
        </Grid>
      ) : (
        <Skeleton />
      )}
    </Grid>
  );
}
